/*
 * @Author: luting
 * @Date: 2022-04-07 10:42:16
 * @lastEditors: luting
 * @LastEditTime: 2022-10-24 09:12:07
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  sysMonitor: '系统监控',
  warnNotification: '告警通知',
  diskPartition: '服务器配置',
  installer: '安装部署',
  monitor: '系统监控',
  syncBack: '备份还原',
  envManage: '运行环境管理',
  packageManage: '安装包管理',
});
